import React from 'react';
import i18n from 'i18n-js';

import { useMappedState } from 'redux-react-hook';

import ViewHeader from '../layouts/AppHeader';

import { useDashboardData, processFullDemosObj } from '../../hooks/metrics/esdata';

import ViewContent from './ViewContent';
import { getQueryVariable } from '../../../routeUtils';

const mapState = state => ({
  filter: state.filters.filter
});

export default function Performance(props) {
  const { filter } = useMappedState(mapState);

  const type = getQueryVariable('type');

  const { responseJourney, responseFullDemos, responseFullDemosPrev } = useDashboardData(filter, {
    qJourney: true,
    qFullDemos: true,
    qFullDemosPrev: true
  });

  const fullDemosObj = processFullDemosObj(responseFullDemos);
  const fullDemosPrevObj = processFullDemosObj(responseFullDemosPrev);

  return (
    <div className="view">
      <ViewHeader
        title={i18n.t('journey_title')}
        subtitle={i18n.t(type === 'ooh' ? 'journey_text_ooh' : 'journey_text')}
      />
      <ViewContent
        filter={filter}
        responseJourney={responseJourney}
        fullDemosObj={fullDemosObj}
        fullDemosPrevObj={fullDemosPrevObj}
        type={type}
      />
    </div>
  );
}
